import {Component, OnInit} from '@angular/core';
import {ModalNavigationService} from '../../services/gui/modal/modal-navigation.service';

@Component({
  selector: 'sb-clipboard-list-input-modal',
  templateUrl: './sb-clipboard-list-input-modal.component.html',
  styleUrls: ['./sb-clipboard-list-input-modal.component.scss'],
  standalone: false,
})
export class SbClipboardListInputModalComponent implements OnInit {
  public entries: string[];

  constructor(private modalNavigation: ModalNavigationService) {
    this.entries = [];
  }

  ngOnInit(): void {}

  public onEntriesChanged(entries: string[]): void {
    this.entries = entries;
  }

  public close(): void {
    this.modalNavigation.result(this.entries);
  }
}
